/** Beneficial Owner Letters (Appendix) 문서 컴포넌트 ↔ 패널 공유 상태. */
import type { InjectionKey, Ref } from 'vue';
import type { BoAppendixDocCode, BoAppendixFieldType } from './boAppendixFields';
import type { SignerEntry } from '@/features/AI-documents/types/docGen.types';
import type { BoAppendixCriteriaState } from './mapBoJsonToAppendix';

export interface BoAppendixDocContext {
  valueOf: (key: string) => string;
  labelOf: (key: string) => string;
  typeOf: (key: string) => BoAppendixFieldType;
  activeKey: Ref<string>;
  activate: (key: string) => void;
  setFieldValue: (key: string, val: string) => void;
  openAddress: (key: string) => void;

  entityCd: Ref<string>;
  signersOf: (varKey: string) => SignerEntry[];
  setSigners: (varKey: string, list: SignerEntry[]) => void;

  pendingPickValue: Ref<string>;
  placePick: (key: string) => boolean;

  /** 문서별 Category / Criteria (Corporate·Individual 독립) */
  criteriaOf: (docCode: BoAppendixDocCode) => BoAppendixCriteriaState;
  toggleCat: (docCode: BoAppendixDocCode, key: keyof BoAppendixCriteriaState['cat']) => void;
  toggleCrit: (docCode: BoAppendixDocCode, key: keyof BoAppendixCriteriaState['crit']) => void;
  setCriteriaPct: (
    docCode: BoAppendixDocCode,
    pctKey: keyof BoAppendixCriteriaState['pct'],
    val: string,
  ) => void;

  /** Race / Gender / Nationality 콤보 (CONTACT MY / MBRS) */
  comboOptionsOf: (key: string) => { value: string; label: string }[];
}

export const BO_APPENDIX_DOC_CTX: InjectionKey<BoAppendixDocContext> = Symbol('boAppendixDocCtx');
